import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProductsPage from "@/pages/ProductsPage";

export const Route = createFileRoute("/products/")({
  head: () => pageHead("All Products | Software, Hardware & Compute", "Explore the Agentic Enterprise Platform, custom agentic software and decision support, enterprise hardware, and custom compute solutions.", "/products", false),
  component: ProductsPage,
});
